import type { VerificationButtonState } from '@/constants/check-verification.constants'

export interface VerificationCheckLike {
  checkMethod: string | null
  checkinLatitude: string | number | null
  checkinLongitude: string | number | null
  checkoutLatitude: string | number | null
  checkoutLongitude: string | number | null
}

const hasCoord = (v: string | number | null | undefined): boolean =>
  v !== null && v !== undefined && v !== '' && !Number.isNaN(Number(v))

/**
 * Decide o botão da coluna "Local e biometria". Usa `checkMethod` do backend
 * (não a origem nem o tipo dos anexos): é a única fonte que diz se houve biometria.
 */
export function getVerificationButtonState(
  check: VerificationCheckLike | null
): VerificationButtonState {
  if (!check) return 'NONE'
  if (check.checkMethod === 'BIOMETRIC') return 'BIOMETRY'
  const hasIn = hasCoord(check.checkinLatitude) && hasCoord(check.checkinLongitude)
  const hasOut = hasCoord(check.checkoutLatitude) && hasCoord(check.checkoutLongitude)
  return hasIn || hasOut ? 'LOCATION' : 'NONE'
}
